import { Component, inject, OnInit, AfterViewChecked, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { AssistantService, ChatMessage } from '@adgate/common/services/assistant-service';
import { RESTApplicationResponse } from '@adgate/common/types/rest-application-response.type';

@Component({
  selector: 'app-assistant-dialog-component',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    FormsModule
  ],
  templateUrl: './assistant-dialog-component.html',
  styleUrl: './assistant-dialog-component.scss',
})
export class AssistantDialogComponent implements OnInit, AfterViewChecked 
{
  private dialogRef: MatDialogRef<AssistantDialogComponent> = inject(MatDialogRef<AssistantDialogComponent>);
  private assistantService: AssistantService = inject(AssistantService);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  @ViewChild('messagesContainer') private messagesContainer!: ElementRef;

  messages: ChatMessage[] = [];
  userInput: string = '';
  isTyping: boolean = false;
  private shouldScrollToBottom = false;

  ngOnInit(): void
  {
    // Initial bot message
    this.messages.push({
      content: 'Hi, I\'m the AdGate assistant. What can i help you with today?',
      isBot: true,
      timestamp: Date.now()
    });
  }

  ngAfterViewChecked(): void 
  {
    if (this.shouldScrollToBottom) {
      this.scrollToBottom();
      this.shouldScrollToBottom = false;
    }
  }

  onSendMessage(): void 
  {
    if (!this.userInput.trim()) return;

    // Add user message
    this.messages.push({
      content: this.userInput,
      isBot: false,
      timestamp: Date.now()
    });

    const userMessage = this.userInput;
    this.userInput = '';
    this.shouldScrollToBottom = true;
    this.isTyping = true;

    // Call the assistant service
    this.assistantService.sendMessage(userMessage, this.messages).subscribe({
      next: (r:RESTApplicationResponse) => {
        this.isTyping = false;
        this.messages.push(r.data);
        this.shouldScrollToBottom = true;
        this.cdr.detectChanges();
      },
      error: (err:Error) => {
        this.isTyping = false;
        this.messages.push({
          content: 'Sorry, there was a problem processing your request. Please try again.',
          isBot: true,
          timestamp: Date.now()
        });
        this.shouldScrollToBottom = true;
        this.cdr.detectChanges();
      }
    });
  }

  onKeyPress(event: KeyboardEvent): void 
  {
    if (event.key === 'Enter') {
      this.onSendMessage();
    }
  }

  private scrollToBottom(): void 
  {
    try {
      if (this.messagesContainer) {
        this.messagesContainer.nativeElement.scrollTop = this.messagesContainer.nativeElement.scrollHeight;
      }
    } catch (err) {
      console.error('Scroll error:', err);
    }
  }

  onClose(): void 
  {
    this.dialogRef.close();
  }
}
